export function useSlideTitle() {
  return `Weekly Commodity Prices`;
}
